export default {"src":"/_next/static/media/facebookIcon.6543d7c4.svg","height":18,"width":11,"blurWidth":0,"blurHeight":0};